import styled from 'styled-components';

import { BaseButton } from './BaseButton';

export const UpButton = styled(BaseButton)`
    top: 0;
    left: 50%;
    transform: translateX(-50%) rotate(90deg);
`;
